var $f75563e3d0557c8d$exports = {};
$f75563e3d0557c8d$exports = {
    "endTime": `Befejez\xe9s ideje`,
    "startTime": `Kezd\xe9s ideje`,
    "time": `Id\u{151}`
};


export {$f75563e3d0557c8d$exports as default};
//# sourceMappingURL=hu-HU.mjs.map
